module.exports = require('./head');



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/lodash/first.js
 ** module id = 1664
 ** module chunks = 0
 **/